import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { Timeline } from "../components/Timeline";
import { Leadership, CTA, Numbers, HeroicCoreThoughtCard, StrategicPillars } from "../components/Sections";
import { Reveal } from "../components/motion";
import {
  TAGLINE, COMPANY_PURPOSE, COMPANY_VISION,
  COMPANY_MISSION, COMPANY_CORE_THOUGHT, LEGAL_ENTITY, SOCIAL_LINKS
} from "../data";
import { Target, Eye, Compass, Sparkles, Lightbulb, Linkedin, Instagram, Github, MapPin } from "lucide-react";

export default function About() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NeuraVolt Technology",
    "legalName": LEGAL_ENTITY,
    "url": "https://neuravolt.in/about",
    "slogan": TAGLINE,
    "description": COMPANY_CORE_THOUGHT,
    "sameAs": [
      SOCIAL_LINKS.linkedin,
      SOCIAL_LINKS.linkedin_profile,
      SOCIAL_LINKS.instagram,
      SOCIAL_LINKS.github,
      SOCIAL_LINKS.google_maps,
    ],
    "knowsAbout": [
      "Artificial Intelligence",
      "Enterprise Software Engineering",
      "Connected Digital Ecosystems",
      "Cloud Infrastructure",
      "IoT Automation"
    ]
  };

  return (
    <Layout>
      <Seo
        title="About Us - Intelligent Solutions. Measurable Impact."
        description={`NeuraVolt (${LEGAL_ENTITY}) brings fragmented technology together into one connected ecosystem. ${COMPANY_CORE_THOUGHT}`}
        keywords="about Neuravolt, VOLTNOVATE SOLUTIONS LLP, connected technology ecosystem, AI first software company India, enterprise engineering, Startup India DPIIT"
        path="/about"
        jsonLd={jsonLd}
      />

      <PageHero
        eyebrow="ABOUT NEURAVOLT"
        title="One Connected Ecosystem for Modern Technology"
        sub={
          <>
            <span className="block">Bringing Intelligent Solutions for Measurable Impact.</span>
            <span className="block mt-1 sm:mt-1.5">
              Recognized under Startup India (DPIIT) &amp; incorporated as VOLTNOVATE SOLUTIONS LLP.
            </span>
          </>
        }
      />

      {/* Strategic Foundation: Core Thought, Purpose, Vision & Mission */}
      <section className="py-20 px-5 sm:px-8">
        <div className="max-w-7xl mx-auto space-y-12">
          {/* Core Thought Featured Banner */}
          <Reveal>
            <HeroicCoreThoughtCard showExploreButton={false} />
          </Reveal>

          {/* 3 Pillars: Purpose, Vision & Mission */}
          <StrategicPillars />
        </div>
      </section>

      <Numbers />
      <Timeline />
      <Leadership />
      <CTA />
    </Layout>
  );
}
